module.exports = __webpack_public_path__ + "img/tablaDental.f444c51a.svg";